import { useState } from "react";
import { Card, Input, Label, Title } from "../CommonComponents/DataCard";
import Button from "../CommonComponents/Button";
import { addIllustrator } from "../../services/IllustratorService";

function AddIllustratorModal({ isOpen, onClose, onIllustratorAdded }) {
    const [form, setForm] = useState({
        name: "",
        surname: ""
    });

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    if (!isOpen) return null;

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    const handleSubmit = async () => {
        setError("");
        setLoading(true);
        try {
            const newIllustrator = await addIllustrator(form);
            onIllustratorAdded(newIllustrator);
            onClose();
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };
    return (

        <div
            onClick={handleOverlayClick} style={{
                position: "fixed",
                top: 0, left: 0,
                width: "100vw", height: "100vh",
                backgroundColor: "rgba(0,0,0,0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,

            }}>
            <Card style={{ width: "400px", maxHeight: "90vh", overflowY: "auto" }}>
                <Title>Dodaj novog ilustratora</Title>

                <Label>Ime:</Label>
                <Input name="name" value={form.name} onChange={handleChange} />

                <Label>Prezime:</Label>
                <Input name="surname" value={form.surname} onChange={handleChange} />

                {error && <div style={{ color: "red", margin: "8px 0" }}>{error}</div>}

                <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px", marginTop: "16px" }}>
                    <Button akcija={onClose} tekst="Odustani" />
                    <Button akcija={handleSubmit} tekst={loading ? "Spremanje..." : "Dodaj"} />
                </div>
            </Card>
        </div>
    );
}

export default AddIllustratorModal;
